<template>
  <ContactUsComponent
    :is-visible="showContactModal"
    @close="closeContactModal"
  />
  <div class="wrapper-fashion">
    <MenuComponent
      logoUrl="assets/logos/LogoPurple.svg"
      textColor="var(--purple)"
      menuIcon="assets/icons/MenuPurple.svg"
      closeIcon="assets/icons/ClosePurple.svg"
    />

    <PrincipalSection
      title="FOTOGRAFÍA DE MODA"
      text="Diseñamos imagen de moda que influye directamente en la decisión de compra"
      overlayColor="var(--purple)"
      layout="media-left"
      mediaType="image"
      mediaSrc="assets/fashion/InitialImage.png"
      mediaAlt="Fotografía de moda"
      buttonText="Agenda una llamada"
      buttonBackground="var(--white)"
      buttonTextColor="var(--purple)"
      buttonShadow="light"
      @button-click="openContactModal"
    />

    <div class="section-container reverse">
      <div class="content-container">
        <p class="section-title">Fotografía y video <b>EDITORIAL</b></p>

        <p class="section-text">
          Construimos aspiracional, elevamos percepción y posicionamos tu marca
          en su categoría
        </p>

        <GenericButton
          text="Ver galería"
          backgroundColor="var(--purple)"
          textColor="var(--white)"
          shadowType="dark"
          @click="goToEditorialGallery"
        />
      </div>

      <div class="media-container">
        <img
          class="section-media"
          src="assets/fashion/Image1.png"
          alt="Fotografía y video editorial"
        />
      </div>
    </div>

    <div class="section-container">
      <div class="media-container">
        <img
          class="section-media"
          src="assets/fashion/Image2.png"
          alt="Fotografía y video ecommerce"
        />
      </div>
      <div class="content-container">
        <p class="section-title">Fotografía y video <b>ECOMMMERCE</b></p>

        <p class="section-text">
          Reducimos fricción, eliminamos dudas y aceleramos la decisión de
          compra
        </p>

        <GenericButton
          text="Ver galería"
          backgroundColor="var(--purple)"
          textColor="var(--white)"
          shadowType="dark"
          @click="goToFashionEcommerceGallery"
        />
      </div>
    </div>

    <FooterComponent overlayColor="var(--purple)" />
  </div>
</template>

<script>
import MenuComponent from "@/ux/layout/components/MenuComponent.vue";
import GenericButton from "../../components/commons/controls/GenericButton.vue";
import PrincipalSection from "../layout/components/PrincipalSection.vue";
import FooterComponent from "@/ux/layout/components/FooterComponent.vue";
import { fashionUse } from "../fashion/use/fashionUse";
import ContactUsComponent from "../sharedComponents/ContactUsComponent.vue";
import { contactUsUse } from "../sharedComponents/use/contactUsUse";

export default {
  name: "FashionView",
  components: {
    MenuComponent,
    PrincipalSection,
    GenericButton,
    FooterComponent,
    ContactUsComponent,
  },

  setup() {
    const { goToEditorialGallery, goToFashionEcommerceGallery } = fashionUse();

    const { showContactModal, openContactModal, closeContactModal } =
      contactUsUse();

    return {
      goToEditorialGallery,
      goToFashionEcommerceGallery,
      showContactModal,
      openContactModal,
      closeContactModal,
    };
  },
};
</script>

<style scoped lang="scss">
@import "src/ux/fashion/styles/fashionStyle";
</style>
